import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiInputBase from '@mui/material/InputBase';
import 'regenerator-runtime/runtime';
import { useAsyncDebounce } from 'react-table';
import { ReactComponent as ForwardRef$1 } from '../../../../assets/icons/CloseSmall.svg.js';
import { ReactComponent as ForwardRef } from '../../../../assets/icons/SearchMedium.svg.js';

const Root = styled(MuiBox, { shouldForwardProp: prop => prop !== 'rtl' }) `
  ${({ width, rtl, theme }) => `
    direction: ${rtl ? 'rtl' : 'ltr'};
    min-width: ${width || theme.spacing(70)};
    height: inherit;
    position: relative;
  `}
`;
const _SearchIcon = styled(ForwardRef, { shouldForwardProp: prop => prop !== 'rtl' }) `
  ${({ theme, rtl }) => `
   direction: ${rtl ? 'rtl' : 'ltr'};
   opacity: 0.5;
   height: ${theme.spacing(4)};
   width: ${theme.spacing(4)};
   position: absolute;
   right: ${rtl ? theme.spacing(1.5) : theme.spacing(0)};
   left: ${rtl ? theme.spacing(0) : theme.spacing(1.5)};
   top: 50%;
   transform: translateY(-50%);
 `}
`;
const _CloseIcon = styled(ForwardRef$1, { shouldForwardProp: prop => prop !== 'rtl' }) `
  ${({ theme, rtl }) => `
    position: absolute;
    right: ${rtl ? 'auto' : theme.spacing(1.5)};
    left: ${rtl ? theme.spacing(1.5) : 'auto'};
    top: 50%;
    transform: translateY(-50%);

    > path {
      fill: ${theme.palette.primary.light};
    }

    &:hover {
      opacity: 0.5;
      cursor: pointer;
    }
  `}
`;
const SearchField = styled(MuiInputBase, { shouldForwardProp: prop => prop !== 'rtl' }) `
  ${({ theme, rtl }) => `
    direction: ${rtl ? 'rtl' : 'ltr'};
    width: 100%;
    height: 100%;

    > input {
      color: ${theme.palette.N20.main};
      border: 1px solid ${theme.palette.N50.main};
      border-radius: ${theme.spacing(1.25)};
      background: transparent;
      outline: none;
      width: 100%;
      height: 100%;
      padding: ${theme.spacing(0, 8, 0, 8)};

      &:focus {
        border: 1px solid ${theme.palette.primary.main};
      }
    }
  `}
`;
const SearchBar = (_a) => {
    var _b;
    var { globalFilter, setGlobalFilter, rtl, disabled, searchInputProps = {} } = _a, rest = __rest(_a, ["globalFilter", "setGlobalFilter", "rtl", "disabled", "searchInputProps"]);
    const [value, setValue] = useState(globalFilter);
    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined);
    }, 200);
    const clearValue = () => {
        setValue('');
        onChange('');
    };
    return (jsxs(Root, Object.assign({}, rest, { rtl: rtl }, { children: [jsx(_SearchIcon, { rtl: rtl }), jsx(SearchField, Object.assign({ rtl: rtl, value: value || '', disabled: disabled, onChange: e => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }, placeholder: (_b = searchInputProps.placeholder) !== null && _b !== void 0 ? _b : 'Search' }, searchInputProps)), value && jsx(_CloseIcon, { onClick: clearValue, rtl: rtl })] })));
};

export { SearchBar as default };
//# sourceMappingURL=SearchBar.js.map
